import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
import { delay } from "../utils/utils";
class ButtonLoader {
  constructor(target, options) {
    this.target = target;
    if (!target.hasClass("animate-button")) this.init(options);
    this.pluginName = "animateButton";
    this.actions = {
      start: this.startLoader,
      finish: this.finishLoader,
      reset: this.resetLoader
    };
  }
  init() {
    const originalContent = this.target.html();
    const originalDimensions = this.getTargetDimensions();
    this.target.addClass("animate-button");
    this.target.html(`<span class="original-content"> ${originalContent} </span>`);
    this.target.append(`
        <span class="animation-content" style="display:none;>
          <span class="animation-loader ld ld-ring ld-spin-fast"></span>
        </span>
      `);
    this.setLoaderHeight();
    this.target.css("width", originalDimensions.width + "px").css("height", originalDimensions.height + "px");
  }
  animate(action, data = "") {
    const actionFn = this.actions[action].bind(this);
    if (!actionFn) throw this.getError(`${action} is not a valid action.`);
    return actionFn(data);
  }
  setContextColors() {
    const rgbWhite = "rgb(255, 255, 255)";
    let bgColor = this.target.css("background-color");
    let color = this.target.css("color");
    if (bgColor === rgbWhite) {
      [bgColor, color] = [color, bgColor];
    }
    this.target.css("--animate-color", color);
    this.target.css("--animate-bg-color", bgColor);
  }
  startLoader() {
    const target = this.target;
    if (target.hasClass("animation-started")) return this;
    this.setContextColors();
    if (!target.hasClass("simple-button")) {
      target.attr("disabled", true);
    }
    _findInstanceProperty(target).call(target, ".original-content").hide();
    _findInstanceProperty(target).call(target, ".animation-content").html("<span class='animation-loader ld ld-ring ld-spin-fast'></span>").show();
    this.setLoaderHeight();
    target.removeClass("animation-finished");
    target.addClass("animation-started");
    return this;
  }
  async finishLoader(status = "success") {
    const iconElem = `<i class="fa ${status == "failed" ? "fa-times" : "fa-check"}" aria-hidden="true"></i>`;
    const target = this.target;
    const content = _findInstanceProperty(target).call(target, ".animation-content");
    if (status != "no-icon") {
      await delay(600);
      content.html(`
          <span class="animation-icon" style="display:none;">
            ${iconElem}
          </span>
        `);
      if (status === "failed") {
        content.addClass("animation-content-error");
      }
    } else {
      await delay(1200);
      content.empty();
      _findInstanceProperty(target).call(target, ".original-content").fadeIn(200);
    }
    target.addClass("animation-finished");
    await delay(600);
    target.removeClass("animation-started");
    if (status != "no-icon") {
      _findInstanceProperty(content).call(content, ".animation-icon").show();
      await delay(600);
    }
    target.removeClass("animation-finished");
    content.removeClass("animation-content-error");
    this.resetLoader();
    return this;
  }
  resetLoader() {
    const target = this.target;
    if (!target.hasClass("simple-button")) {
      target.attr("disabled", false);
    }
    const originalContent = _findInstanceProperty(target).call(target, ".original-content");
    target.removeClass("animation-started");
    _findInstanceProperty(target).call(target, ".animation-content").fadeOut(200, () => {
      target.removeClass("animate-button");
      originalContent.fadeIn(200, () => {
        target.css("width", "");
        target.css("height", "");
        target.html(originalContent.html());
      });
    });
    return this;
  }
  getError(message) {
    return `${this.pluginName}: ${message}`;
  }
  setLoaderHeight() {
    const target = this.target;
    const buttonHeight = target.outerHeight();
    _findInstanceProperty(target).call(target, ".animation-loader").css("width", buttonHeight + "px").css("height", buttonHeight + "px");
  }
  getTargetDimensions() {
    const target = this.target;
    return {
      width: target.outerWidth(),
      height: target.outerHeight()
    };
  }
}
export default {
  init($) {
    $.fn.animateButton = function (options) {
      const opts = $.extend({}, $.fn.animateButton.defaults, options);
      const instance = new ButtonLoader(this.first(), opts);
      return instance;
    };
    $.fn.animateButton.defaults = {};
  }
};